import React, { useState,useRef,useEffect } from 'react';
import './DeleteConfirmationModal.scss';

const DeleteConfirmationModal = ({ isOpen, itemType = '', onConfirm, onCancel }) => {
  const [isDeleting, setIsDeleting] = useState(false);
  const modalRef = useRef(null);

    useEffect(() => {
      const handleClickOutside = (event) => {
        // If the modal ref exists and the click is outside of its content, call onCancel
        if (modalRef.current && !modalRef.current.contains(event.target)) {
          onCancel();
        }
      };
  
      // Add event listener when the modal is open
      if (isOpen) {
        document.addEventListener("mousedown", handleClickOutside);
      }
  
      // Cleanup function to remove the event listener
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [isOpen, onCancel])

  if (!isOpen) return null;



  const handleConfirm = async () => {
    if (isDeleting) return; // Prevent multiple clicks
    
    setIsDeleting(true);
    try {
      await onConfirm();
    } finally {
      setIsDeleting(false);
    }
  };

  return (
    <div className="delete-modal-backdrop">
      <div ref={modalRef} className="delete-modal">
        <h3>Confirm Deletion</h3>
        <p>Are you sure you want to delete <strong>{itemType}</strong>?</p>
        <div className="delete-modal-actions">
          <button 
            className={`confirm-btn ${isDeleting ? 'deleting' : ''}`}
            onClick={handleConfirm}
            disabled={isDeleting}
          >
            {isDeleting ? (
              <>
                <span className="spinner"></span>
                Deleting...
              </>
            ) : (
              'Yes, Delete'
            )}
          </button>
          <button 
            className="cancel-btn" 
            onClick={onCancel}
            disabled={isDeleting}
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteConfirmationModal;